import moment from "moment";
import { FunctionField, NumberField, ReferenceField, Show, Tab, TabbedShowLayout, TextField } from "react-admin";
import {useLocation} from "react-router-dom";
import VasMappingTransactionsTab from "./VasMappingTransactionsTab";

const VasUserMappingShowTabs = () => {
    // const [, setUserBundleMappingId] = useStore<number | null>('vasMappingTabs_userBundleServiceMappingId', null)

    let location = useLocation();
    let vasMappingId = location.pathname.split('/')[2]
    // useEffect(() => setUserBundleMappingId(parseInt(userBundleId)))

    return (
        <TabbedShowLayout>
            <Tab label={"Details"}>
                <TextField source="id" />
                <ReferenceField source="vasId" reference="Vas"><TextField source="name" /></ReferenceField>
                <NumberField source="vas.id" />
                <NumberField source="totalVisits" />
                <FunctionField label="Start Date" render={(record: any) => record?.startDate ? moment(record.startDate).format('DD MMM YYYY') : '-'} />
                <FunctionField label="End Date" render={(record: any) => record?.endDate ? moment(record.endDate).format('DD MMM YYYY') : '-'} />
                <NumberField source="totalTaken" />
                <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY') : '-'} />
                <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY') : '-'} />
            </Tab>

            <Tab label={"Vas Transactions"}>
                <VasMappingTransactionsTab vasMappingId={parseInt(vasMappingId)}/>
                {/*<Resource*/}
                {/*    name="UserServiceTransactionsForBundleMappings"*/}
                {/*    list={UserTransactionList} />*/}
            </Tab>
        </TabbedShowLayout>
    )
}

const VasUserMappingShow = () => (
    <Show>
        <VasUserMappingShowTabs />
    </Show>
);

export default VasUserMappingShow;
